import { BaseShippingMethodsClient } from "../types/clients";
import { PickupPoint, ShippingMethod } from "@core/types";
import { convertShippingMethod } from "./converters";
import { client } from "../../../../apollo";
import {
  ShippingMethodsByIdQuery,
  ShippingMethodsByIdDocument,
  PickupPointsByZoneIdQuery,
  PickupPointsByZoneIdDocument,
} from "../../../../generated/graphql";

class ShippingMethodsClient extends BaseShippingMethodsClient {
  async getShippingMethods(zoneId?: string, productsWeight?: number): Promise<ShippingMethod[]> {
    const methods: ShippingMethod[] = await client
      .query<ShippingMethodsByIdQuery>({
        query: ShippingMethodsByIdDocument,
        variables: {
          zoneId,
          productsWeight,
        },
      })
      .then((res) => {
        if (res.data) {
          return res.data.customerShippingMethodsByZoneId.edges.map(({ node }) => convertShippingMethod(node));
        }

        return [];
      });

    return methods;
  }

  async getPickupPoints(zoneId?: string): Promise<PickupPoint[]> {
    const points: PickupPoint[] = await client
      .query<PickupPointsByZoneIdQuery>({
        query: PickupPointsByZoneIdDocument,
        variables: {
          zoneId: zoneId,
        },
      })
      .then((res) => {
        if (res.data) {
          return res.data.pickupPointsByZoneId;
        }

        return [];
      });

    return points;
  }
}

export default ShippingMethodsClient;
